<template>
  <b-container class="px-0" fluid>
    <b-col class="px-2" style="display: flex; flex-direction: row-reverse;">
      <b-row align-h="end" class="col-lg-6 col-12 pl-0">
        <origin-filter>
          <v-select
            id="stock-origin-selector"
            slot="options"
            class="origin-selector col"
            :clearable="false"
            v-model="stockSelected"
            :options="stock_site_origin"
            @input="updateStockContext()"/>
        </origin-filter>
      </b-row>
    </b-col>
  </b-container>
</template>

<script>
import OriginFilter from '@/components/OriginFilter.vue'

export default {
  mounted() {
    this.stockSelected.code = this.$store.getters.stockOriginSelectedCode
    this.stockSelected.label = this.stock_site_origin[this.stockSiteOriginSelectedIndex]
      ? this.stock_site_origin[this.stockSiteOriginSelectedIndex].label
      : 'Todas as origens'
  },
  components: {
    OriginFilter
  },
  data: () => ({
    stockSelected: {
      code: null,
      label: null
    }
  }),
  computed: {
    is_multi_site_manager() { return this.$store.getters.is_multi_site_manager },
    stock_context_loaded() { return this.$store.getters.stock_context_loaded },
    stock_site_origin() { return this.$store.getters.stock_site_origin },

    stockSiteOriginSelectedIndex() { return this.$store.getters.stockSiteOriginSelectedIndex },
    stockSiteOriginText() { return this.stock_site_origin[this.stockSiteOriginSelectedIndex].label }  // Esse cara usa index de lista
  },
  methods: {
    updateStockContext() {
      this.$store.commit('updateStockSiteOriginSelectedIndex', this.stockSelected.code);
      this.$store.commit('updateCommonContext', {
        'url': 'product/dashboard/product/',
        'payload': { 'site_origin': this.stockSelected.site_or_origin }
      })
      this.$store.commit('updateStockOriginSelectedCode', this.stockSelected.code)
    }
  }
}
</script>

<style>

</style>
